// =========================================================
// frontend/js/admin.js (V11.5) - Split: Mitarbeiter & RBAC-Matrix
// =========================================================

/**
 * 1. EIGENSTÄNDIGE ANSICHT: MITARBEITER
 */
// =========================================================
// frontend/js/admin.js (V12.0 - CSRD Snapshot & Global Overview)
// =========================================================

/**
 * 0. GLOBALER IMPACT OVERVIEW (CSRD Kernstück)
 * Zeigt die aggregierten Daten des gesamten Unternehmens.
 */
// =========================================================
// frontend/js/admin.js (V12.1 - CSRD & Impact Report Buttons)
// =========================================================

/**
 * 0. GLOBALER IMPACT OVERVIEW
 * Zeigt die aggregierten Daten des gesamten Unternehmens.
 */
window.renderAdminDashboardHTML = function() {
    // Wir nutzen die globale Statistik, die von app.js (syncGlobalImpact) berechnet wird
    // Falls diese noch nicht geladen ist, machen wir eine schnelle Live-Summierung
    let totalCO2 = 0;
    const currentYear = new Date().getFullYear().toString();

    (window.events || []).forEach(e => {
        if (e.status === 'APPROVED' && (e.type === 'HO' || e.type === 'homeoffice') && e.date?.startsWith(currentYear)) {
            totalCO2 += (e.co2SavedAtBooking || 0);
        }
    });

    const totalTrees = (totalCO2 / 12.5).toFixed(1);

    return `
        <div class="p-12 max-w-7xl animate-fadeIn">
            
            <div class="flex flex-col md:flex-row justify-between items-start md:items-end mb-10 gap-4">
                <div>
                    <h3 class="text-4xl font-black text-slate-800 tracking-tighter">Unternehmens-Impact</h3>
                    <p class="text-xs text-slate-400 font-bold uppercase tracking-widest mt-2">CSRD-Kennzahlen & Nachhaltigkeits-Reporting</p>
                </div>
                
                <div class="flex gap-4">
                    <button onclick="window.render(window.renderReportHTML)" class="bg-blue-50 text-blue-600 border border-blue-200 px-6 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest shadow-sm hover:bg-blue-600 hover:text-white transition-all flex items-center gap-2">
                        <i data-lucide="line-chart" class="w-4 h-4"></i> Marketing Impact
                    </button>
                    // <button onclick="window.render(window.renderCSRDReportHTML)" class="bg-slate-900 text-white px-6 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest shadow-xl hover:bg-emerald-600 transition-all flex items-center gap-2">
                      //  <i data-lucide="shield-check" class="w-4 h-4"></i> CSRD Audit Report
                    // </button>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                <div class="bg-slate-900 p-10 rounded-[3rem] text-white shadow-2xl relative overflow-hidden group">
                    <div class="absolute -right-10 -top-10 opacity-10 group-hover:scale-110 transition-transform duration-700">
                        <i data-lucide="wind" class="w-40 h-40"></i>
                    </div>
                    <p class="text-emerald-400 text-[10px] font-black uppercase tracking-[0.2em] mb-4">Gespartes CO₂ (Netto)</p>
                    <div class="flex items-end gap-3">
                        <h4 class="text-6xl font-black tracking-tighter">${totalCO2.toFixed(1)}</h4>
                        <span class="text-xl font-bold text-slate-500 mb-2">kg</span>
                    </div>
                </div>

                <div class="bg-white border border-slate-100 p-10 rounded-[3rem] shadow-sm relative overflow-hidden group">
                    <p class="text-slate-400 text-[10px] font-black uppercase tracking-[0.2em] mb-4">Wald-Äquivalent</p>
                    <div class="flex items-end gap-3">
                        <h4 class="text-6xl font-black text-slate-800 tracking-tighter text-emerald-600">${totalTrees}</h4>
                        <span class="text-xl font-bold text-slate-300 mb-2 text-emerald-600/50">🌳</span>
                    </div>
                </div>

                <div class="bg-blue-50 border border-blue-100 p-10 rounded-[3rem] flex flex-col justify-center items-center text-center group">
                    <p class="text-blue-600 text-[10px] font-black uppercase tracking-[0.2em] mb-4">Daten-Integrität</p>
                    <button onclick="window.syncGlobalImpact()" class="bg-white text-blue-600 px-6 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest shadow-sm hover:shadow-md transition-all active:scale-95 flex items-center gap-2">
                        <i data-lucide="refresh-cw" class="w-4 h-4"></i> Snapshot Sync
                    </button>
                    <p class="text-[9px] text-blue-400 mt-4 font-medium italic">Berechnet alle Buchungen revisionssicher neu.</p>
                </div>
            </div>

            <div class="flex gap-4 p-2 bg-slate-100 rounded-3xl w-fit mb-12">
                <button onclick="window.activeAdminSubView='users'; render();" class="px-8 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all ${window.activeAdminSubView === 'users' ? 'bg-white shadow-sm text-slate-800' : 'text-slate-500 hover:text-slate-800'}">Mitarbeiter</button>
                <button onclick="window.activeAdminSubView='roles'; render();" class="px-8 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all ${window.activeAdminSubView === 'roles' ? 'bg-white shadow-sm text-slate-800' : 'text-slate-500 hover:text-slate-800'}">Rechte-Matrix</button>
                <button onclick="window.activeAdminSubView='tree'; render();" class="px-8 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all ${window.activeAdminSubView === 'tree' ? 'bg-white shadow-sm text-slate-800' : 'text-slate-500 hover:text-slate-800'}">Struktur</button>
            </div>

            <div id="admin-subview-container">
                ${window.renderSelectedAdminSubView()}
            </div>
        </div>
    `;
};

window.renderSelectedAdminSubView = function() {
    const sub = window.activeAdminSubView || 'users';
    if (sub === 'users') return window.renderStandaloneUsersTab();
    if (sub === 'roles') return window.renderAdminRolesTab();
    if (sub === 'tree') return window.renderStandaloneTreeTab();
    return '';
};

/**
 * 1. EIGENSTÄNDIGE ANSICHT: MITARBEITER
 */
window.renderStandaloneUsersTab = function() {
    if (!window.hasPermission(window.PERMISSIONS.MANAGE_USERS)) return `<div class="p-12 text-center text-red-500 font-bold">Zugriff verweigert</div>`;

    return `
        <div class="animate-fadeIn">
            <div class="flex justify-between items-end mb-8">
                <div>
                    <h3 class="text-2xl font-black text-slate-800 tracking-tighter">Benutzerverwaltung</h3>
                </div>
                <button onclick="typeof window.openMemberModal === 'function' ? window.openMemberModal() : alert('Member Modul lädt noch')" class="bg-emerald-600 text-white px-8 py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl hover:bg-black transition-all flex items-center gap-2">
                    <i data-lucide="user-plus" class="w-4 h-4"></i> Neu anlegen
                </button>
            </div>

            <div class="bg-white rounded-[3rem] border border-slate-200 shadow-sm overflow-hidden">
                <div class="grid grid-cols-[2fr_1fr_1fr] gap-4 p-6 bg-slate-50 border-b border-slate-200 text-[10px] font-black text-slate-400 uppercase tracking-widest">
                    <div>Name & Organisation</div>
                    <div>Berechtigungs-Rolle</div>
                    <div class="text-right">Individuelle Optionen</div>
                </div>
                <div class="divide-y divide-slate-100">
                    ${(window.usersList || []).map(user => window.renderUserAdminRow(user)).join('')}
                </div>
            </div>
        </div>
        <div id="permissions-modal-container"></div>
        <div id="member-modal-container"></div>
    `;
};


window.renderUserAdminRow = function(user) {
    if (!user) return ''; // Safety Guard

    const extraCount = Array.isArray(user.extraPermissions) ? user.extraPermissions.length : 0;
    const scopeCount = user.managedScopes ? Object.keys(user.managedScopes).length : 0; 
    
    const flatTree = typeof window.getFlattenedTree === 'function' ? window.getFlattenedTree(window.orgStructure || []) : [];
    const unitMatch = flatTree.find(item => item.id === user.nodeId);
    const unitPath = unitMatch ? unitMatch.name : '<span class="text-slate-300 italic font-medium uppercase text-[9px]">Keine Zuordnung</span>';
    
    // Safety initials calculation
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    const initials = (firstName[0] || '') + (lastName[0] || '');

    return `
        <div class="grid grid-cols-[2fr_1fr_1fr] gap-4 p-6 items-center border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
            <div class="flex items-center gap-4">
                <div class="w-14 h-14 bg-blue-100 text-blue-600 font-black rounded-2xl flex justify-center items-center shadow-sm text-lg">
                    ${initials}
                </div>
                <div>
                    <p class="font-black text-slate-800 text-base">${firstName} ${lastName}</p>
                    <div class="flex items-center gap-1.5 text-[10px] text-slate-400 font-bold mt-1 uppercase tracking-tight">
                        <i data-lucide="network" class="w-3.5 h-3.5"></i> ${unitPath}
                    </div>
                </div>
            </div>
            <div>
                <select onchange="window.updateUserRoleInDB('${user.uid}', this.value)" 
                    class="bg-white border-2 border-slate-100 rounded-xl px-4 py-2.5 text-sm font-bold w-full max-w-[220px] outline-none focus:border-blue-500 transition-all">
                    ${Object.keys(window.activeRoles || {}).map(role => `<option value="${role}" ${user.role === role ? 'selected' : ''}>${role}</option>`).join('')}
                </select>
            </div>
            <div class="flex justify-end gap-2">
                 <button onclick="window.openMemberModal('${user.uid}')" title="Profil" class="p-3 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-2xl transition-all"><i data-lucide="edit-2" class="w-5 h-5"></i></button>
                 <button onclick="window.openScopeMatrixModal('${user.uid}')" title="Abteilungen" class="p-3 text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 rounded-2xl relative transition-all">
                     <i data-lucide="git-merge" class="w-5 h-5"></i>
                     ${scopeCount > 0 ? `<span class="absolute -top-1 -right-1 w-5 h-5 bg-emerald-500 text-white text-[9px] rounded-full flex items-center justify-center">${scopeCount}</span>` : ''}
                 </button>
                 <button onclick="window.openPermissionsModal('${user.uid}')" title="Rechte" class="p-3 text-slate-400 hover:text-purple-600 hover:bg-purple-50 rounded-2xl relative transition-all">
                     <i data-lucide="shield-check" class="w-5 h-5"></i>
                     ${extraCount > 0 ? `<span class="absolute -top-1 -right-1 w-5 h-5 bg-purple-500 text-white text-[9px] rounded-full flex items-center justify-center">${extraCount}</span>` : ''}
                 </button>
             </div>
        </div>
    `;
};

/**
 * 2. EIGENSTÄNDIGE ANSICHT: RECHTE-MATRIX (RBAC)
 */
window._secureRoleMemory = null; 
window._isFetchingRoles = false;

// Gruppiert alle verfügbaren Rechte sauber auf
function getPermissionGroups(allPerms) {
    const groups = {
        'Kalender & Buchungen': [],
        'Buchbare Status-Arten': [],
        'Administration & HR': [],
        'System & Einstellungen': []
    };

    allPerms.forEach(p => {
        if (p.startsWith('status_')) groups['Buchbare Status-Arten'].push(p);
        else if (p.startsWith('calendar_') || p.startsWith('vacation_')) groups['Kalender & Buchungen'].push(p);
        else if (p.startsWith('hr_') || p.startsWith('manage_') || p.startsWith('view_approvals')) groups['Administration & HR'].push(p);
        else if (!p.startsWith('scope_')) groups['System & Einstellungen'].push(p);
    });
    return groups;
}

window.renderAdminRolesTab = function() {
    if (window._secureRoleMemory === null && window.currentUser?.companyId) {
        if (!window._isFetchingRoles) {
            window._isFetchingRoles = true;
            db.collection('companies').doc(window.currentUser.companyId).collection('settings').doc('roles').get()
            .then(doc => {
                window._secureRoleMemory = doc.exists ? doc.data() : {};
                window.activeRoles = { ...window.activeRoles, ...window._secureRoleMemory };
                window._isFetchingRoles = false;
                window.render(); 
            });
        }
        return `<div class="p-24 text-center text-slate-400 animate-pulse font-black uppercase tracking-widest text-xs">Lade Rechte-Matrix...</div>`;
    }

    const roles = window.activeRoles || {};
    // OWNER filtern wir raus, da der Owner hardcoded sowieso alles darf
    const roleNames = Object.keys(roles).filter(r => r !== 'OWNER');

    let allAvailablePermissions = Object.values(window.PERMISSIONS || {}).filter(p => !p.startsWith('scope_'));
    if (window.statusTypes && window.statusTypes.length > 0) {
        window.statusTypes.forEach(st => allAvailablePermissions.push(`status_${st.id}`));
    }
    const groupedPerms = getPermissionGroups(allAvailablePermissions);

    return `
        <div class="p-12 animate-fadeIn max-w-[1600px]">
            <div class="flex justify-between items-end mb-8">
                <div>
                    <h3 class="text-4xl font-black text-slate-800 tracking-tighter">Rechte-Matrix (RBAC)</h3>
                    <p class="text-xs text-slate-400 font-bold uppercase tracking-widest mt-2">Globale Rollen und Zugriffssteuerung</p>
                </div>
                <button onclick="window.openNewRoleModal()" class="bg-blue-600 text-white px-8 py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl hover:bg-black transition-all">
                    <i data-lucide="plus-circle" class="w-4 h-4 inline mr-2"></i> Neue Rolle
                </button>
            </div>

            <div class="bg-white rounded-[3rem] border border-slate-200 shadow-sm overflow-hidden">
                <div class="overflow-x-auto w-full max-w-[calc(100vw-300px)]">
                    <table class="w-full text-left border-collapse min-w-[800px]">
                        <thead>
                            <tr class="bg-slate-50">
                                <th class="p-6 sticky left-0 z-20 bg-slate-50 border-b border-r border-slate-200 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.05)] w-[300px]">
                                    <span class="text-[10px] font-black text-slate-400 uppercase tracking-widest">Berechtigung</span>
                                </th>
                                ${roleNames.map(rName => `
                                    <th class="p-6 border-b border-slate-200 text-center min-w-[140px]">
                                        <span class="font-black text-slate-800 px-4 py-2 bg-white rounded-xl text-xs uppercase tracking-widest border border-slate-200 shadow-sm inline-block">${rName}</span>
                                    </th>
                                `).join('')}
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-100">
                            ${Object.entries(groupedPerms).map(([groupName, perms]) => {
                                if (perms.length === 0) return '';
                                
                                let html = `
                                    <tr class="bg-slate-100/50">
                                        <td colspan="${roleNames.length + 1}" class="px-6 py-3 sticky left-0 font-black text-[10px] uppercase text-blue-600 tracking-widest">
                                            <i data-lucide="folder-open" class="w-3 h-3 inline mr-2"></i> ${groupName}
                                        </td>
                                    </tr>
                                `;

                                perms.forEach(perm => {
                                    let displayLabel = perm;
                                    let desc = "System-Berechtigung";
                                    if (perm.startsWith('status_')) {
                                        const stId = perm.replace('status_', '');
                                        const statusObj = (window.statusTypes || []).find(s => s.id === stId);
                                        displayLabel = statusObj ? statusObj.name : perm;
                                        desc = "Darf diesen Status buchen";
                                    }

                                    html += `
                                        <tr class="hover:bg-slate-50 transition-colors group">
                                            <td class="p-4 px-6 sticky left-0 bg-white group-hover:bg-slate-50 border-r border-slate-100 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.02)] z-10">
                                                <p class="font-bold text-slate-700 text-sm tracking-tight">${displayLabel}</p>
                                                <p class="text-[9px] font-bold text-slate-400 uppercase tracking-widest mt-1 font-mono">${desc}</p>
                                            </td>
                                            ${roleNames.map(rName => {
                                                const hasPerm = (roles[rName] || []).includes(perm);
                                                return `
                                                    <td class="p-4 text-center border-l border-slate-50 relative">
                                                        <label class="absolute inset-0 flex items-center justify-center cursor-pointer">
                                                            <input type="checkbox" onchange="window.toggleMatrixPermission('${rName}', '${perm}', this.checked)" class="w-5 h-5 text-blue-600 rounded border-slate-300 focus:ring-blue-500 shadow-sm transition-all" ${hasPerm ? 'checked' : ''}>
                                                        </label>
                                                    </td>
                                                `;
                                            }).join('')}
                                        </tr>
                                    `;
                                });
                                return html;
                            }).join('')}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div id="permissions-modal-container"></div>
    `;
};

// Logik: Wird gefeuert, wenn du einen Haken in der Matrix setzt
window.toggleMatrixPermission = async function(roleName, perm, isChecked) {
    if (!window.activeRoles[roleName]) window.activeRoles[roleName] = [];
    
    if (isChecked) {
        if (!window.activeRoles[roleName].includes(perm)) window.activeRoles[roleName].push(perm);
    } else {
        window.activeRoles[roleName] = window.activeRoles[roleName].filter(p => p !== perm);
    }

    try {
        await window.updateRoleTemplateInDB(window.currentUser.companyId, roleName, window.activeRoles[roleName]);
        window._secureRoleMemory = null; 
        if (window.showToast) window.showToast(`Rechte für ${roleName} aktualisiert!`);
    } catch (e) {
        alert("Fehler beim Speichern: " + e.message);
        window.render();
    }
};

window.openNewRoleModal = function() {
    const rawName = prompt("Name der neuen Rolle (z.B. ABTEILUNGSLEITER):");
    if (!rawName) return;
    const cleanName = rawName.trim().toUpperCase().replace(/[^A-Z0-9_]/g, '');
    
    if (window.activeRoles[cleanName]) return alert("Diese Rolle existiert bereits!");

    window.updateRoleTemplateInDB(window.currentUser.companyId, cleanName, [])
    .then(() => {
        window._secureRoleMemory = null;
        window.render(); 
    });
};


/**
 * 3. EIGENSTÄNDIGE ANSICHT: STRUKTUR & TEAMS
 */
window.selectedNodeId = null;

window.renderStandaloneTreeTab = function() {
    if (!window.hasPermission(window.PERMISSIONS.MANAGE_TREE)) return `<div class="p-12 text-center text-red-500 font-bold">Zugriff verweigert</div>`;

    return `
        <div class="p-12 max-w-[1600px] animate-fadeIn">
            <div class="mb-10">
                <h3 class="text-4xl font-black text-slate-800 tracking-tighter">Struktur & Team-Verwaltung</h3>
                <p class="text-xs text-slate-400 font-bold uppercase tracking-widest mt-2">Klicke eine Ebene an, um Mitarbeiter zuzuordnen</p>
            </div>
            
            <div class="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
                <div class="lg:col-span-5 bg-white rounded-[3rem] border border-slate-200 shadow-sm p-8 min-h-[650px]">
                    <div id="tree-editor-container">
                        ${typeof window.renderAdminTreeTab === 'function' ? window.renderAdminTreeTab() : '<div class="p-10">Lade Struktur...</div>'}
                    </div>
                </div>

                <div class="lg:col-span-7" id="team-member-panel">
                    ${window.renderNodeMembersPanel()}
                </div>
            </div>
        </div>
    `;
};


/**
 * 4. MODALS FÜR INDIVIDUELLE RECHTE (Aufruf aus dem "Mitarbeiter"-Reiter)
 */

// Modal: Scope-Matrix (Zuständigkeiten der User für Abteilungen)
window.openScopeMatrixModal = function(uid) {
    const user = window.usersList.find(u => u.uid === uid);
    if (!user) return;

    const userScopes = user.managedScopes || {};
    const tree = window.orgStructure || [];

    if (tree.length === 0) {
        alert("Bitte lege zuerst unter 'Struktur & Ebenen' dein Unternehmen an.");
        return;
    }

    const modalHTML = `
        <div id="matrix-modal" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fadeIn">
            <div class="bg-white rounded-[3rem] shadow-2xl w-full max-w-4xl flex flex-col max-h-[85vh]">
                <div class="p-10 border-b border-slate-100 shrink-0 bg-emerald-50/30 rounded-t-[3rem]">
                    <h3 class="text-2xl font-black text-slate-800 tracking-tight flex items-center gap-3">
                        <i data-lucide="git-merge" class="text-emerald-600"></i> Zuständigkeits-Matrix
                    </h3>
                    <p class="text-slate-500 text-xs font-bold mt-2">
                        Lege explizit fest, für welche Abteilungen/Standorte <span class="text-emerald-700">${user.firstName} ${user.lastName}</span> verantwortlich ist.
                    </p>
                </div>

                <div class="p-0 overflow-y-auto flex-1 bg-white">
                    <div class="sticky top-0 bg-white border-b border-slate-100 flex justify-between p-4 px-10 text-[10px] font-black text-slate-400 uppercase tracking-widest z-10 shadow-sm">
                        <div class="w-1/2">Struktur-Ebene</div>
                        <div class="w-1/2 flex justify-end gap-16 pr-8">
                            <span>Sichtbar</span>
                            <span>Bearbeiten</span>
                            <span class="text-rose-500">Pflichttermine</span>
                        </div>
                    </div>
                    <div class="p-4 px-6">
                        ${window.buildMatrixTreeHTML(tree, userScopes)}
                    </div>
                </div>

                <div class="p-8 border-t border-slate-100 flex gap-4 shrink-0 bg-slate-50 rounded-b-[3rem]">
                    <button onclick="window.saveScopeMatrixModal('${uid}')" class="flex-1 bg-emerald-600 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-black transition shadow-xl shadow-emerald-100">
                        Matrix Speichern
                    </button>
                    <button onclick="document.getElementById('matrix-modal').remove()" class="px-8 py-4 bg-white border border-slate-200 text-slate-600 font-bold rounded-2xl hover:bg-slate-50 transition">
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    `;
    document.getElementById('permissions-modal-container').innerHTML = modalHTML;
    if (window.lucide) lucide.createIcons();
};

window.buildMatrixTreeHTML = function(nodes, userScopes, depth = 0) {
    let html = '';
    nodes.forEach(node => {
        const nodeId = node.id;
        const scopes = userScopes[nodeId] || [];
        
        const hasView = scopes.includes(window.PERMISSIONS.SCOPE_VIEW) ? 'checked' : '';
        const hasEdit = scopes.includes(window.PERMISSIONS.SCOPE_EDIT) ? 'checked' : '';
        const hasMandatory = scopes.includes(window.PERMISSIONS.SCOPE_MANDATORY) ? 'checked' : '';
        
        html += `
            <div class="flex items-center justify-between p-3 border-b border-slate-50 hover:bg-slate-50 rounded-xl transition-colors group" style="margin-left: ${depth * 2}rem;">
                <div class="font-bold text-slate-700 text-sm flex items-center gap-3">
                    ${depth > 0 ? '<i data-lucide="corner-down-right" class="w-4 h-4 text-slate-300"></i>' : '<i data-lucide="building" class="w-5 h-5 text-slate-400"></i>'}
                    ${node.name}
                </div>
                <div class="flex gap-14 pr-8 opacity-60 group-hover:opacity-100 transition-opacity">
                    <label class="cursor-pointer flex items-center justify-center">
                        <input type="checkbox" class="matrix-cb w-5 h-5 text-blue-600 rounded border-slate-300 focus:ring-blue-500" 
                               data-node="${nodeId}" value="${window.PERMISSIONS.SCOPE_VIEW}" ${hasView}>
                    </label>
                    <label class="cursor-pointer flex items-center justify-center">
                        <input type="checkbox" class="matrix-cb w-5 h-5 text-emerald-600 rounded border-slate-300 focus:ring-emerald-500" 
                               data-node="${nodeId}" value="${window.PERMISSIONS.SCOPE_EDIT}" ${hasEdit}>
                    </label>
                    <label class="cursor-pointer flex items-center justify-center">
                        <input type="checkbox" class="matrix-cb w-5 h-5 text-rose-600 rounded border-slate-300 focus:ring-rose-500" 
                               data-node="${nodeId}" value="${window.PERMISSIONS.SCOPE_MANDATORY}" ${hasMandatory}>
                    </label>
                </div>
            </div>
        `;
        if (node.children && node.children.length > 0) {
            html += window.buildMatrixTreeHTML(node.children, userScopes, depth + 1);
        }
    });
    return html;
};

window.saveScopeMatrixModal = async function(uid) {
    const checkboxes = document.querySelectorAll('.matrix-cb:checked');
    const newScopesObj = {};

    checkboxes.forEach(cb => {
        const nodeId = cb.getAttribute('data-node');
        const permValue = cb.value;
        if (!newScopesObj[nodeId]) newScopesObj[nodeId] = [];
        newScopesObj[nodeId].push(permValue);
    });

    try {
        if (typeof window.updateUserScopesInDB === 'function') {
            await window.updateUserScopesInDB(uid, newScopesObj);
        }
        const uIndex = window.usersList.findIndex(u => u.uid === uid);
        if (uIndex > -1) window.usersList[uIndex].managedScopes = newScopesObj;
        
        document.getElementById('matrix-modal').remove();
        window.render(); 
    } catch (e) { alert("Fehler beim Speichern der Matrix: " + e.message); }
};

// Modal: Globale Sonder-Rechte für einen einzelnen Mitarbeiter
window.openPermissionsModal = function(uid) {
    const user = window.usersList.find(u => u.uid === uid);
    if (!user) return;

    let userExtras = Array.isArray(user.extraPermissions) ? user.extraPermissions : [];
    const userRole = user.role || 'EMPLOYEE';
    let basePermissions = Array.isArray(window.activeRoles[userRole]) ? window.activeRoles[userRole] : [];
    
    let allAvailablePermissions = Object.values(window.PERMISSIONS || {});
    if (window.statusTypes && window.statusTypes.length > 0) {
        window.statusTypes.forEach(st => allAvailablePermissions.push(`status_${st.id}`));
    }

    const modalHTML = `
        <div id="perm-modal" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fadeIn">
            <div class="bg-white rounded-[3rem] shadow-2xl w-full max-w-lg flex flex-col max-h-[85vh]">
                <div class="p-10 border-b border-slate-100 shrink-0">
                    <h3 class="text-xl font-black text-slate-800 tracking-tight">Globale Sonder-Rechte</h3>
                    <p class="text-slate-400 text-[10px] font-bold uppercase tracking-widest mt-1">Mitarbeiter: ${user.firstName} ${user.lastName}</p>
                </div>
                <div class="p-8 overflow-y-auto space-y-3 bg-slate-50/30 flex-1">
                    ${allAvailablePermissions.map(perm => {
                        if (perm.startsWith('scope_')) return ''; 
                        const isBase = basePermissions.includes(perm);
                        const isExtra = userExtras.includes(perm);     
                        const isChecked = isBase || isExtra;
                        const isDisabled = isBase; 
                        
                        let displayLabel = perm;
                        if (perm.startsWith('status_')) {
                            const stId = perm.replace('status_', '');
                            const statusObj = (window.statusTypes || []).find(s => s.id === stId);
                            if (statusObj) displayLabel = `Status buchen: ${statusObj.name}`;
                        }

                        return `
                            <label class="flex items-center justify-between p-5 bg-white border border-slate-200 rounded-[1.5rem] ${isDisabled ? 'opacity-50 bg-slate-50 cursor-not-allowed' : 'cursor-pointer hover:border-purple-300 transition shadow-sm'}">
                                <div>
                                    <span class="font-bold text-slate-700 text-sm font-mono tracking-tighter">${displayLabel}</span>
                                    ${isBase ? `<p class="text-[9px] font-black text-purple-500 mt-1 uppercase tracking-[0.1em]">🔒 Inkludiert in Rolle ${userRole}</p>` : ''}
                                </div>
                                <input type="checkbox" value="${perm}" class="perm-checkbox w-6 h-6 text-purple-600 rounded-lg border-slate-300 shadow-sm" ${isChecked ? 'checked' : ''} ${isDisabled ? 'disabled' : ''}>
                            </label>
                        `;
                    }).join('')}
                </div>
                <div class="p-8 border-t border-slate-100 flex gap-4 shrink-0 bg-white">
                    <button onclick="window.savePermissionsModal('${uid}')" class="flex-1 bg-purple-600 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-black transition shadow-xl">Sonder-Rechte sichern</button>
                    <button onclick="document.getElementById('perm-modal').remove()" class="px-8 py-4 bg-slate-100 text-slate-600 font-bold rounded-2xl hover:bg-slate-200 transition">Schließen</button>
                </div>
            </div>
        </div>
    `;
    document.getElementById('permissions-modal-container').innerHTML = modalHTML;
    if (window.lucide) lucide.createIcons();
};

window.savePermissionsModal = async function(uid) {
    const checkboxes = document.querySelectorAll('.perm-checkbox:checked:not([disabled])');
    const newPermissions = Array.from(checkboxes).map(cb => cb.value);
    try {
        if (typeof window.updateUserExtraPermissionsInDB === 'function') {
            await window.updateUserExtraPermissionsInDB(uid, newPermissions); 
        }
        const uIndex = window.usersList.findIndex(u => u.uid === uid);
        if (uIndex > -1) window.usersList[uIndex].extraPermissions = newPermissions;
        document.getElementById('perm-modal').remove();
        window.render(); 
    } catch (e) {
        alert("Fehler beim Speichern: " + e.message);
    }
};

/**
 * 5. TEAM-MANAGEMENT LOGIK (Für Struktur-Tab)
 */
window.selectTreeNode = function(nodeId) {
    window.selectedNodeId = nodeId;
    const panel = document.getElementById('team-member-panel');
    if (panel) {
        panel.innerHTML = window.renderNodeMembersPanel();
        if (window.lucide) lucide.createIcons();
    }
};

window.renderNodeMembersPanel = function() {
    if (!window.selectedNodeId) {
        return `
            <div class="bg-slate-100/50 border-2 border-dashed border-slate-200 rounded-[3rem] h-[650px] flex flex-col items-center justify-center text-center p-12">
                <div class="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-slate-300 mb-4 shadow-sm">
                    <i data-lucide="mouse-pointer-2" class="w-8 h-8"></i>
                </div>
                <p class="text-slate-500 font-bold">Wähle links eine Ebene aus,<br>um die Mitarbeiter dieses Teams zu verwalten.</p>
            </div>
        `;
    }

    const flatTree = typeof window.getFlattenedTree === 'function' ? window.getFlattenedTree(window.orgStructure || []) : [];
    const node = flatTree.find(n => n.id === window.selectedNodeId);
    
    const members = (window.usersList || []).filter(u => u.nodeId === window.selectedNodeId);
    const nonMembers = (window.usersList || []).filter(u => u.nodeId !== window.selectedNodeId);

    return `
        <div class="bg-white rounded-[3rem] border border-slate-200 shadow-xl p-10 min-h-[650px] animate-fadeIn relative overflow-hidden">
            <div class="absolute top-0 right-0 p-10 opacity-5 pointer-events-none">
                <i data-lucide="users" class="w-32 h-32 text-blue-900"></i>
            </div>

            <div class="relative z-10">
                <div class="flex justify-between items-start mb-10">
                    <div>
                        <p class="text-blue-600 text-[10px] font-black uppercase tracking-widest mb-1">Gewähltes Team</p>
                        <h4 class="text-3xl font-black text-slate-800">${node?.name || 'Unbekannte Ebene'}</h4>
                    </div>
                    <div class="bg-blue-50 text-blue-600 px-5 py-2 rounded-2xl text-xs font-black border border-blue-100">
                        ${members.length} Personen
                    </div>
                </div>

                <div class="mb-10 p-8 bg-slate-50 rounded-[2.5rem] border border-slate-100 shadow-inner">
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4 ml-2">Neues Mitglied hinzufügen</label>
                    <div class="flex gap-3">
                        <select id="add-member-select" class="flex-1 bg-white border border-slate-200 rounded-2xl px-6 py-4 font-bold text-slate-700 outline-none focus:border-blue-500 shadow-sm transition-all">
                            <option value="">Mitarbeiter suchen...</option>
                            ${nonMembers.map(u => `<option value="${u.uid}">${u.firstName} ${u.lastName} (${u.role})</option>`).join('')}
                        </select>
                        <button onclick="window.assignUserToNode()" class="bg-blue-600 text-white px-8 py-4 rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-black transition-all shadow-lg shadow-blue-100">
                            Hinzufügen
                        </button>
                    </div>
                </div>

                <div class="space-y-4">
                    <h5 class="text-[10px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-2">Teammitglieder</h5>
                    ${members.length === 0 ? `
                        <div class="py-12 text-center border-2 border-dashed border-slate-100 rounded-[2rem] text-slate-400 font-medium">
                            Dieses Team hat aktuell noch keine Mitglieder.
                        </div>
                    ` : members.map(u => `
                        <div class="flex items-center justify-between p-5 bg-white border border-slate-100 rounded-3xl hover:border-blue-200 transition-all shadow-sm group">
                            <div class="flex items-center gap-4">
                                <div class="w-12 h-12 bg-slate-50 text-slate-400 rounded-2xl flex items-center justify-center font-bold text-sm border border-slate-100 group-hover:bg-blue-50 group-hover:text-blue-600 transition-colors">
                                    ${u.firstName[0]}${u.lastName[0]}
                                </div>
                                <div>
                                    <p class="font-bold text-slate-800">${u.firstName} ${u.lastName}</p>
                                    <p class="text-[10px] text-slate-400 font-black uppercase tracking-widest">${u.role}</p>
                                </div>
                            </div>
                            <button onclick="window.removeUserFromNode('${u.uid}')" class="p-3 text-slate-200 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all" title="Aus Team entfernen">
                                <i data-lucide="user-minus" class="w-5 h-5"></i>
                            </button>
                        </div>
                    `).join('')}
                </div>
            </div>
        </div>
    `;
};

window.assignUserToNode = async function() {
    const uid = document.getElementById('add-member-select').value;
    if (!uid) return;
    try {
        await window.updateUserInCloud(uid, { nodeId: window.selectedNodeId });
        const user = window.usersList.find(u => u.uid === uid);
        if (user) user.nodeId = window.selectedNodeId;
        window.showToast("Teammitglied erfolgreich hinzugefügt!");
        window.selectTreeNode(window.selectedNodeId); 
    } catch (e) { window.showToast("Fehler: " + e.message, true); }
};

window.removeUserFromNode = async function(uid) {
    if (!confirm("Mitglied aus diesem Team entfernen?")) return;
    try {
        await window.updateUserInCloud(uid, { nodeId: "" });
        const user = window.usersList.find(u => u.uid === uid);
        if (user) user.nodeId = "";
        window.showToast("Zuordnung aufgehoben.");
        window.selectTreeNode(window.selectedNodeId);
    } catch (e) { window.showToast("Fehler: " + e.message, true); }
};